/**
 * Editor-chrome colors for the LivePreview canvas — selection / hover / group /
 * marquee outlines drawn on top of the report sheet.
 *
 * These are DELIBERATELY fixed values, not light/dark theme tokens. The A4 sheet
 * is a WYSIWYG print surface (it always renders as white "paper" so what the user
 * designs matches the printed / exported PDF), so the chrome painted over it must
 * read identically regardless of the app's theme. Centralised here (rather than
 * inlined per render path) so the selection language stays consistent across the
 * flow / absolute / group boundaries.
 *
 * Two accent families by positioning mode: indigo for absolute + group selection,
 * violet for flow-item selection.
 */
export const SELECTION_PALETTE = {
  /** Primary selection accent (indigo-500): page-center guide, group markers, selected absolute/group outline. */
  selected: '#6366f1',
  /** Hover outline on the absolute / group path (indigo-300). */
  hover: '#a5b4fc',
  /** Unselected group bounding box (indigo-200). */
  groupBoundary: '#c7d2fe',
  /** Flow-item selected outline (violet-600). */
  flowSelected: '#7c3aed',
  /** Flow-item hover outline (violet-300). */
  flowHover: '#c4b5fd',
  /** Marquee rubber-band border (blue-500) and its translucent fill. */
  marquee: '#3b82f6',
  marqueeFill: 'rgba(59,130,246,0.08)',
} as const;
